// import COMPANY_API from '@/api/masterData/company.js';
// import BASE_API from '@/api/dataBase';
export const tableColumns = (ctx) => {
  // console.log(ctx.departmentCode, 'customerPayMethodOne');
  return [
    {
      prop: 'applyDepartmentName',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList || [],
      changeMethod: 'changeMethod',
    },
    {
      name: '投标抬头',
      prop: 'bidTitle',
      type: 'select',
      options: ctx.companyList || [],
      changeMethod: 'changeMethod',
    },
    {
      name: '服务类型',
      prop: 'serviceTypeCode',
      type: 'select',
      options: [
        { value: 'CC', label: '仓储服务' },
        { value: 'JG', label: '监管服务' },
      ],
      // type: 'dict',
      // dictType: 'WAREHOUSE_SERVICE_TYPE',
      changeMethod: 'changeMethod',
    },
    {
      name: '业务人员',
      prop: 'bidderId',
      type: 'searchTableSpec',
      isMultiple: true,
      currentValue: ctx.baseInfoData.bidderName,
      changeMethod: 'changeMethod',
      searchType: 'personnel',
      extraData: {
        dataStatus: 'ZT03',
        personCompanyCode: ctx.userInfo.companyCode,
        personDepartmentCode: ctx.userInfo.departmentCode,
      },
    },
    {
      name: '立项申请日期',
      prop: 'applyDate',
      type: 'startDaterangePickerTime',
      changeMethod: 'changeMethod',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      type: 'input',
    },
    {
      name: '项目编号',
      prop: 'projectCode',
      type: 'input',
      placeholder: '自动生成',
      disabled: true,
    },
    {
      name: '投标总金额',
      prop: 'bidTotalAmount',
      type: 'inputAmount',
      max: 9999999999.99,
      precision: 2,
    },
    {
      name: '项目负责人',
      prop: 'projectResponsiblePerson',
      type: 'input',
    },
    {
      name: '项目来源',
      prop: 'projectSourceType',
      type: 'select',
      options: [
        { value: 'SWQT', label: '商务洽谈' },
        { value: 'TB', label: '投标' },
        { value: 'OT', label: '其他' },
      ],
    },
    {
      name: '开标日期',
      prop: 'bidOpeningDate',
      type: 'startDaterangePickerTime',
      changeMethod: 'changeMethod',
    },
    {
      name: '截标日期',
      prop: 'bidClosingDate',
      type: 'endDaterangePickerTime',
      changeMethod: 'changeMethod',
    },
    {
      name: '联动单位',
      prop: 'linkedCompanyCode',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      currentValue: ctx.baseInfoData.linkedCompanyName,
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    {
      name: '项目性质',
      prop: 'projectNature',
      type: 'select',
      options: [
        { value: 'PIBT10', label: '双方' },
        { value: 'PIBT11', label: '三方' },
        { value: 'PIBT12', label: '四方' },
      ],
      changeMethod: 'changeMethod',
    },
    {
      name: '项目状态',
      prop: 'projectStatusName',
      // type: 'ajaxSelect',
      // apiUrl: BASE_API.DIC_CREDIT_API,
      // apiData: { dictType: 'WAREHOUSE_PROJECT_STATUS' },
      type: 'dict',
      dictType: 'WAREHOUSE_PROJECT_STATUS',
      placeholder: '自动填写',
      disabled: true,
    },
    {
      name: '客户1名称',
      prop: 'customerCodeOne',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      currentValue: ctx.baseInfoData.customerNameOne,
      changeMethod: 'changeMethod',
      isMultiple: true,
      isHidden: !ctx.visibleField.includes('customerCodeOne'),
    },
    {
      name: '客户1类型',
      prop: 'customerTypeOne',
      type: 'dict',
      dictType: 'warehouseProjectCustomerType',
      changeMethod: 'changeMethod',
      isHidden: ctx.hideCustomerTypeOne == true || !ctx.visibleField.includes('customerTypeOne'),
    },
    {
      name: '客户1企业性质',
      prop: 'customerNatureOne',
      type: 'dict',
      dictType: 'enterprise_type',
      isHidden: !ctx.visibleField.includes('customerNatureOne'),
    },
    {
      name: '客户1法人',
      prop: 'customerLegalPersonOne',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerLegalPersonOne'),
    },
    {
      name: '客户1联系人',
      prop: 'customerContactPersonOne',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactPersonOne'),
    },
    {
      name: '客户1联系电话',
      prop: 'customerContactPhoneOne',
      type: 'input',
      // placeholder:'请输入客户1联系电话',
      // max: 99999999999,
      // precision: 0,
      isHidden: !ctx.visibleField.includes('customerContactPhoneOne'),
    },
    {
      name: '客户1联系邮箱',
      prop: 'customerContactEmailOne',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactEmailOne'),
    },
    {
      name: '客户1付款方式',
      prop: 'customerPayMethodOne',
      // type: 'ajaxSelect',
      // apiUrl: BASE_API.DIC_CREDIT_API,
      // apiData: { dictType: 'payment_method' },
      // currentValue: ctx.baseInfoData.customerPayMethodOne,
      type: 'dict',
      dictType: 'apply_payment_method',
      isHidden: !ctx.visibleField.includes('customerPayMethodOne'),
    },
    {
      name: '客户2名称',
      prop: 'customerCodeTwo',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      currentValue: ctx.baseInfoData.customerNameTwo,
      changeMethod: 'changeMethod',
      isMultiple: true,
      isHidden: !ctx.visibleField.includes('customerCodeTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2类型',
      prop: 'customerTypeTwo',
      type: 'dict',
      dictType: 'warehouseProjectCustomerType',
      changeMethod: 'changeMethod',
      isHidden:
        ctx.hideCustomerTypeOne == true ||
        (!ctx.visibleField.includes('customerTypeTwo') &&
          !ctx.baseInfoData.customerCodeTwo &&
          ctx.hideCustomerTypeOne == false),
    },
    {
      name: '客户2企业性质',
      prop: 'customerNatureTwo',
      type: 'dict',
      dictType: 'enterprise_type',
      isHidden:
        !ctx.visibleField.includes('customerNatureTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2法人',
      prop: 'customerLegalPersonTwo',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerLegalPersonTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2联系人',
      prop: 'customerContactPersonTwo',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerContactPersonTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2联系电话',
      prop: 'customerContactPhoneTwo',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerContactPhoneTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2联系邮箱',
      prop: 'customerContactEmailTwo',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerContactEmailTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户2结算方式',
      prop: 'customerPayMethodTwo',
      type: 'dict',
      dictType: 'apply_payment_method',
      isHidden:
        !ctx.visibleField.includes('customerPayMethodTwo') && !ctx.baseInfoData.customerCodeTwo,
    },
    {
      name: '客户3名称',
      prop: 'customerCodeThree',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01',
        departmentCode: ctx.departmentCode,
        companyCode: ctx.companyCode,
      },
      currentValue: ctx.baseInfoData.customerNameThree,
      changeMethod: 'changeMethod',
      isMultiple: true,
      isHidden:
        !ctx.visibleField.includes('customerCodeThree') && !ctx.baseInfoData.customerCodeThree,
    },
    {
      name: '客户3类型',
      prop: 'customerTypeThree',
      type: 'dict',
      dictType: 'warehouseProjectCustomerType',
      changeMethod: 'changeMethod',
      isHidden:
        ctx.hideCustomerTypeOne == true ||
        (!ctx.visibleField.includes('customerTypeThree') &&
          !ctx.baseInfoData.customerCodeThree &&
          ctx.hideCustomerTypeOne == false),
    },
    {
      name: '客户3企业性质',
      prop: 'customerNatureThree',
      type: 'dict',
      dictType: 'enterprise_type',
      isHidden:
        !ctx.visibleField.includes('customerNatureThree') && !ctx.baseInfoData.customerCodeThree,
    },
    {
      name: '客户3法人',
      prop: 'customerLegalPersonThree',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerLegalPersonThree') &&
        !ctx.baseInfoData.customerCodeThree,
    },
    {
      name: '客户3联系人',
      prop: 'customerContactPersonThree',
      type: 'input',
      isHidden: !ctx.visibleField.includes('customerContactPersonThree'),
    },
    {
      name: '客户3联系电话',
      prop: 'customerContactPhoneThree',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerContactPhoneThree') &&
        !ctx.baseInfoData.customerCodeThree,
    },
    {
      name: '客户3联系邮箱',
      prop: 'customerContactEmailThree',
      type: 'input',
      isHidden:
        !ctx.visibleField.includes('customerContactEmailThree') &&
        !ctx.baseInfoData.customerCodeThree,
    },
    {
      name: '项目开始日期',
      prop: 'projectStartDate',
      type: 'startDaterangePickerTime',
      changeMethod: 'changeMethod',
    },
    {
      name: '项目结束日期',
      prop: 'projectEndDate',
      type: 'endDaterangePickerTime',
      changeMethod: 'changeMethod',
    },
    {
      name: '项目盈利模式',
      prop: 'projectProfitModel',
      type: 'input',
    },
    {
      name: '项目盈利说明',
      prop: 'projectProfitDescription',
      type: 'input',
    },
    {
      name: '项目风险点',
      prop: 'projectRiskPoints',
      type: 'input',
    },
    {
      name: '风险防范措施',
      prop: 'riskPreventionMeasures',
      type: 'input',
    },
    {
      name: '创建人',
      prop: 'createByName',
      disabled: true,
      type: 'input',
    },
    {
      name: '创建时间',
      prop: 'gmtCreate',
      disabled: true,
      type: 'date',
    },
    {
      name: '更新人',
      prop: 'lastModifiedByName',
      disabled: true,
      type: 'input',
    },
    {
      name: '更新时间',
      prop: 'gmtModified',
      disabled: true,
      type: 'date',
    },
    {
      name: '项目整体描述',
      prop: 'projectOverallDescription',
      type: 'input',
    },
  ];
};
